import EventEmitter from "./EventEmitter";
import simplify from "simplify-js";

export default class ColorData extends EventEmitter {
  constructor(dimension = { width: 512, height: 512 }) {
    super();
    this.scale = dimension.width / 512;
    this.color_image = document.querySelector("#colorSource");
    this.color_image.width = dimension.width;
    this.color_image.height = dimension.height;
    this.color_ctx = this.color_image.getContext("2d");
    this.setColor(this.color_ctx);

    // EXTRA CANVAS TO RECORD THE COLOR POINTS (HIDDEN)
    // WHILE WE DRAW SCRATCHY LINES
    this.data = document.createElement("canvas");
    this.data.width = dimension.width;
    this.data.height = dimension.height;
    this.data_ctx = this.data.getContext("2d");
    this.setColor(this.data_ctx);
    //
    this.position_image = document.querySelector("#positionSource");
    this.position_image.width = dimension.width;
    this.position_image.height = dimension.height;
    this.position_ctx = this.position_image.getContext("2d");
    this.setColor(this.position_ctx, 0);
    this.initListener();
  }

  set ui(_interface) {
    this._ui = _interface;
  }
  get ui() {
    return this._ui;
  }

  onResize(dimension) {
    this.scale = dimension.width / 512;
    this.color_image.width = dimension.width;
    this.color_image.height = dimension.height;
    this.position_image.width = dimension.width;
    this.position_image.height = dimension.height;
    this.data.width = dimension.width;
    this.data.height = dimension.height;
    this.setColor(this.color_ctx);
    this.setColor(this.data_ctx);
    this.setColor(this.position_ctx, 0);
  }

  initListener() {
    this.handler = {
      click: this.onClick.bind(this),
      down: this.onDown.bind(this),
      move: this.onMove.bind(this),
      up: this.onUp.bind(this),
      contextMenu: this.onContextMenu.bind(this),
    };
    // this.color_image.addEventListener("click", this.handler.click);
    // new interaction
    this.color_image.addEventListener("mousedown", this.handler.down);
    this.color_image.addEventListener("touchstart", this.handler.down);
    this.color_image.addEventListener("mousemove", this.handler.move);
    this.color_image.addEventListener("touchmove", this.handler.move);
    this.color_image.addEventListener("mouseup", this.handler.up);
    this.color_image.addEventListener("touchend", this.handler.up);
    this.color_image.addEventListener("mouseout", this.handler.up);
    this.color_image.addEventListener("contextmenu", this.handler.contextMenu);
  }

  setColor(ctx, color = 255, w = 512, h = 512) {
    ctx.fillStyle = `rgba(${color},${color},${color},255)`;
    ctx.fillRect(0, 0, w, h);
  }

  paint(ctx, x, y, size, color = `#ffffff`) {
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.arc(x, y, size / 2, 0, Math.PI * 2, false);
    ctx.fill();
    ctx.closePath();
  }

  clear() {
    this.setColor(this.color_ctx);
    this.setColor(this.data_ctx);
    this.setColor(this.position_ctx, 0);
  }

  onDown(e) {
    e.preventDefault();
    let event = e;
    this.isDrawing = true;
    if (e.touches) {
      event = e.touches[0];
      const targetPos = event.target.getBoundingClientRect();
      const offsetX = targetPos.left;
      const offsetY = targetPos.top;
      event.layerX = event.clientX - offsetX;
      event.layerY = event.clientY - offsetY;
    } else {
    }
    this.activePoint = [{ x: event.layerX, y: event.layerY }];
    // console.log(this.ui.color_palette.activeRGB);
    this.color_ctx.strokeStyle = this.ui.color_palette.activeColor;
    this.color_ctx.lineWidth = 5 * this.scale;
    this.color_ctx.lineCap = "round";
    // this.color_ctx.beginPath();
    // this.color_ctx.moveTo(event.layerX, event.layerY);
  }
  onMove(e) {
    e.preventDefault();
    if (this.isDrawing) {
      let event = e;
      if (e.touches) {
        event = e.touches[0];
        event = e.touches[0];
        const targetPos = event.target.getBoundingClientRect();
        const offsetX = targetPos.left;
        const offsetY = targetPos.top;
        event.layerX = event.clientX - offsetX;
        event.layerY = event.clientY - offsetY;
      } else {
      }
      this.color_ctx.beginPath();
      this.color_ctx.moveTo(
        this.activePoint[this.activePoint.length - 1].x,
        this.activePoint[this.activePoint.length - 1].y
      );
      this.color_ctx.lineTo(event.layerX, event.layerY);
      this.color_ctx.stroke();
      this.color_ctx.closePath();
      this.activePoint.push({ x: event.layerX, y: event.layerY });
    }
  }
  onUp(e) {
    e.preventDefault();
    // let event = e;
    // if (e.touches) {
    //   event = e.touches[0];
    // } else {
    // }
    this.isDrawing = false;
    // simplify the line
    if (this.activePoint) {
      this.raiseEvent("hascolored", [
        {
          line: simplify(this.activePoint, 0.85),
          color: this.ui.color_palette.activeColor,
        },
      ]);
      // const colorPositions = simplify(this.activePoint, 10);
      //  this.activePoint = null;
      // this.setColorPoints(colorPositions, this.ui.color_palette.activeColor);
      this.convertLines2Points(
        this.activePoint,
        this.ui.color_palette.activeColor
      );
      this.activePoint = null;
    }
  }
  onContextMenu(e) {
    e.preventDefault();
    return false;
  }

  convertLines2Points(line, color) {
    const colorPositions = simplify(line, 10);
    this.setColorPoints(colorPositions, color);
  }

  setColorPoints(colorPositions, color) {
    console.log(colorPositions);
    colorPositions.forEach((point) => {
      this.paint(this.data_ctx, point.x, point.y, 10 * this.scale, color);
      //
      this.paint(this.position_ctx, point.x, point.y, 10 * this.scale);
      // send event
      // this.raiseEvent("hascolored", [{ x: point.x, y: point.y, color: color }]);
    });
  }

  onClick(e) {
    this.paint(
      this.color_ctx,
      e.layerX,
      e.layerY,
      10,
      this.ui.color_palette.activeColor
    );
    // NEW COLOR INFO
    this.paint(
      this.data_ctx,
      e.layerX,
      e.layerY,
      10,
      this.ui.color_palette.activeColor
    );
    //
    this.paint(this.position_ctx, e.layerX, e.layerY, 10);
    this.raiseEvent("hascolored", [
      { x: e.layerX, y: e.layerY, color: this.ui.color_palette.activeColor },
    ]);
  }
}
